import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BaseDtoSearchService, IBaseDto } from './base-dto.service';
import { BaseEstimateClient, QuickSearchEstimatesResultDto } from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class BaseEstimatesService extends BaseDtoSearchService {
    constructor(private readonly client: BaseEstimateClient) {
        super();
    }

    async search(filterText: string): Promise<QuickSearchEstimatesResultDto[]> {
        const body = {
            filterText: filterText
        };
        return await lastValueFrom(this.client.baseEstimateQuickSearch(body));
    }

    override getById(id: number): Promise<IBaseDto> {
        throw new Error('Method not implemented.');
    }

    async getByIds(ids: number[]): Promise<QuickSearchEstimatesResultDto[]> {
        return await lastValueFrom(this.client.baseEstimateGetByIds(ids));
    }
}
